import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import IframeComm from 'react-iframe-comm';

class CtAdminStatus extends Component {
  constructor(props) {
    super(props);
  }

  handleOnReady = () => {
    console.log('IframeComm Ready');
  };

  render() {
    const { handleOnReady } = this;

    const { frameWidth, frameHeight, frameBorder } = this.props;
    const frameSrc = '/' + (this.props.match.params.target ? this.props.match.params.target : 'monit');
    const attributes = {
      src: frameSrc,
      width: frameWidth,
      height: frameHeight,
      frameBorder: frameBorder
    };

    return <IframeComm attributes={attributes} handleReady={handleOnReady} />;
  }
}

CtAdminStatus.propTypes = {};
CtAdminStatus.defaultProps = {
  frameWidth: '100%',
  frameHeight: '100%',
  frameBorder: 0
};

export default withRouter(CtAdminStatus);



// WEBPACK FOOTER //
// ./src/script/containers/admin/CtAdminStatus.js